import { useQuery } from "@tanstack/react-query";
import { api } from "shared/api";

const fetchStandardProductOrder = async (orderId: string) => {
  const res = await api().gersGetStandardProductOrder(orderId);
  return res.data;
};

export const useGetStandardOrder = (orderId: string) => {
  return useQuery({
    queryKey: [`get-standard-order-${orderId}`],
    queryFn: () => fetchStandardProductOrder(orderId),
    enabled: orderId !== "",
  });
};
